import React from 'react';
import { AIRemarksContainer } from '../../remarks/components/aiRemarksContainer';
import { AnalysisRemarkKeys } from '../../remarks/config';
import { useRecommendations } from '../../../hooks/useRecommendations';
import { ErrorDisplay } from '../../../components/ui/error/ErrorDisplay';

interface RecommendationsContainerProps {
  title?: string;
}

const RecommendationsContainer: React.FC<RecommendationsContainerProps> = ({ title }) => {
  const {
    initialValue,
    isLoading,
    error,
    ...remarksProps
  } = useRecommendations();

  // 🔴 Step 4: Show error UI if data fetch failed
  if (error) {
    return (
      <ErrorDisplay
        title="Failed to Load Recommendations"
        error={error}
        onRetry={remarksProps.onGenerate}
      />
    );
  }

  // ⏳ Show skeleton only if loading and no previous value
  if (isLoading && !initialValue) {
    return (
      <div className="animate-pulse">
        <div className="h-8 bg-gray-200 rounded mb-4"></div>
        <div className="h-32 bg-gray-200 rounded mb-4"></div>
      </div>
    );
  }

  return (
    <AIRemarksContainer
      remarkKey={AnalysisRemarkKeys.Recommendations}
      initialValue={initialValue}
      titleTextOverride={title}
      {...remarksProps}
    />
  );
};

export default RecommendationsContainer;
